export default __webpack_public_path__ + "static/media/print.d2e71a39.svg";